import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../environments/environment';

/**
 * Subset of the Color document returned by Item.API. Only the fields the
 * costing UI needs for display — extend as other features need more.
 */
export interface ColorDto {
  /** MongoDB ObjectId; matches RollMonthlyCost.colorReference. */
  id: string;
  name: string;
  /** Lab-dip identifier; null on legacy rows. */
  labDipNumber: string | null;
}

@Injectable({ providedIn: 'root' })
export class LabDipRequestProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/lab-dip-request';

  /**
   * Resolve a list of color references to their Color metadata. The endpoint
   * accepts up to a few hundred references per call — callers with larger
   * sets must chunk client-side. Auth is handled by the global Bearer
   * interceptor; no header work needed here.
   */
  public getColorsByIds(colorReferences: string[]): Observable<ApiResponse<ColorDto[]>> {
    return this.httpClient.post<ApiResponse<ColorDto[]>>(`${this.baseUrl}/by-color/batch/ids`, colorReferences);
  }

  public searchColors(query: string): Observable<ApiResponse<ColorDto[]>> {
    return this.httpClient.post<ApiResponse<ColorDto[]>>(`${this.baseUrl}/color/search`, { colorName: query });
  }
}
